import instance from './instance';
//lazy but cannot search
export default (id) =>
  instance()
    .get(`/coupons/${id}`)
    .then((data) => {
      let dataRes = data.data;
      return dataRes;
    })
    .catch((err) => err);
